export const FACEBOOK_DOMAIN_VERIFICATION = 'f92t0uplvps67mih9c8o4w81dg92vm';
